/**
 * Pre-built app templates for quick start.
 * Each template defines name, description, layout, and default panels.
 */
export const APP_TEMPLATES = [
  {
    id: 'lead-qualifier',
    name: 'Lead Qualifier',
    description: 'Chat-driven lead qualification with data summary. Ideal for sales teams.',
    layout: 'three-panel',
    chatPosition: 'header',
    defaultFlowId: null, // User selects
    panels: [
      { id: 'left_1', type: 'component', position: 'left', order: 0, componentType: 'table', outputKey: 'table_data', flowId: null },
      { id: 'center_1', type: 'chat', position: 'center', order: 0 },
      { id: 'right_1', type: 'component', position: 'right', order: 0, componentType: 'stats', outputKey: 'stats_data', flowId: null },
    ],
  },
  {
    id: 'faq-bot',
    name: 'FAQ Chat Bot',
    description: 'Simple Q&A chatbot with response display. Center-focused chat.',
    layout: 'three-panel',
    chatPosition: 'center',
    defaultFlowId: null,
    panels: [
      { id: 'left_1', type: 'component', position: 'left', order: 0, componentType: 'rich_text', outputKey: 'rich_text', flowId: null },
      { id: 'center_1', type: 'chat', position: 'center', order: 0 },
      { id: 'right_1', type: 'component', position: 'right', order: 0, componentType: 'list', outputKey: 'list_data', flowId: null },
    ],
  },
  {
    id: 'data-dashboard',
    name: 'Data Dashboard',
    description: 'Charts and tables with chat assist. Good for analytics.',
    layout: 'three-panel',
    chatPosition: 'center',
    defaultFlowId: null,
    panels: [
      { id: 'left_1', type: 'component', position: 'left', order: 0, componentType: 'chart', outputKey: 'chart_data', flowId: null, config: { chartType: 'bar' } },
      { id: 'center_1', type: 'chat', position: 'center', order: 0 },
      { id: 'right_1', type: 'component', position: 'right', order: 0, componentType: 'table', outputKey: 'table_data', flowId: null },
    ],
  },
  {
    id: 'minimal-chat',
    name: 'Minimal Chat',
    description: 'Two-panel: chat and summary. Clean, focused layout.',
    layout: 'two-panel',
    chatPosition: 'header',
    defaultFlowId: null,
    panels: [
      { id: 'left_1', type: 'component', position: 'left', order: 0, componentType: 'table', outputKey: 'table_data', flowId: null },
      { id: 'center_1', type: 'chat', position: 'center', order: 0 },
      { id: 'right_1', type: 'component', position: 'right', order: 0, componentType: 'rich_text', outputKey: 'rich_text', flowId: null },
    ],
  },
  {
    id: 'blank',
    name: 'Blank App',
    description: 'Start from scratch with default three-panel layout.',
    layout: 'three-panel',
    chatPosition: 'center',
    defaultFlowId: null,
    panels: [
      { id: 'center_1', type: 'chat', position: 'center', order: 0 },
    ],
  },
];
